import React from 'react'
import { GlassMorphIcon, Image } from '@/components/ui'
import type { IHeaderProps } from './types'

export const Header = (props: IHeaderProps) => {
  const { isPoleLogo } = props

  return isPoleLogo ? (
    <GlassMorphIcon image={'star'} className={'notificationHeader__icon'} />
  ) : (
    <Image className="notificationHeader__logo" src={'logos/polerf.svg'} isInStatic />
  )
}
